'use strict'

// the logic:
// if flag - is true, client code must show modal with textKey text (from i18n files), instead of saving vacancy
const state = {
  flag: false,
  textKey: ''
}

const getters = {
  isNotAllowedToSave(state) {
    return state.flag
  },
  getTextKey(state) {
    return state.textKey
  }
}

const actions = {
  forbidToSave({commit}, options) {
    commit('forbidToSave', options)
  },
  clearRestriction({commit}) {
    commit('clearRestriction')
  }
}

const mutations = {
  forbidToSave(state, {textKey}) {
    state.flag = true
    state.textKey = textKey
  },

  clearRestriction(state) {
    state.flag = false
    state.textKey = ''
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
